module.exports = __webpack_public_path__ + "static/media/IMG_8025.446bd7ba.JPG";